// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3RfmQ","content":"GlobalSearch_content__3U1p6"};